export const statuses = {
    Auto: 'Auto',
    Away: 'Away',
    Home: 'Home',
    Standby: 'Standby',
    Off: 'Off'
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/services/core/home/home.constant.js